import React from 'react';
import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';

const CustomSwitch = styled((props) => <Switch {...props} />)(({ theme }) => ({
  '&.MuiSwitch-root': {
    width: '64px',
    paddingLeft: '0',
    height: '45px'
  },
  '&  .MuiButtonBase-root': {
    top: '5px',
    left: '-2px'
  },
  '&  .MuiButtonBase-root.Mui-checked .MuiSwitch-thumb': {
    backgroundColor: 'primary.main'
  },
  '& .MuiSwitch-thumb': {
    width: '16px',
    height: '16px',
    borderRadius: '5px'
  },

  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[200],
    opacity: 1,
    borderRadius: '5px'
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: 'primary',
        opacity: 0.18
      }
    }
  }
}));

export default CustomSwitch;
